import { AxiosResponse } from "axios";
import { OrganizationKeyName } from "../../../model/Organization";
import { axiosAuthenticated } from "../../../service/http";
import { ApiKey, ApiKeySuccessResponse } from "../model/ApiKey";

export const apiKeysHttp = {
  getApiKeys: async (
    organizationKeyName?: OrganizationKeyName
  ): Promise<ApiKey[]> => {
    const url = `/management/organizations/${organizationKeyName}/api-keys/items`;
    const response = await axiosAuthenticated.get<
      any,
      AxiosResponse<ApiKeySuccessResponse>
    >(url);
    const apiKeys = response.data;
    return apiKeys;
  },
};
